import { createSelector } from 'reselect';
import may from './may';

export const getAuth = state => state.auth;
export const isAuthenticated = createSelector(getAuth, state => !!state && !!state.logged);
export const getId = createSelector(getAuth, state => state.username);
export const getProfile = createSelector(getAuth, state => state.profile);
export const getName = createSelector(getProfile, profile =>
  profile ? `${profile.first_name} ${profile.last_name}` : null
);
export const getFirstName = createSelector(getProfile, profile => profile.first_name);
export const getLastName = createSelector(getProfile, profile => profile.last_name);
export const getFinancial = createSelector(getAuth, state => state.financial);
export const getSubscription = createSelector(getAuth, state => state.subscription);
export const getLocations = createSelector(getAuth, state => state.locations);
export const getLang = createSelector(getAuth, state => state.lang);
export const getTeams = createSelector(getAuth, state => state.teams);
export const getLocation = createSelector(getAuth, state => state.location);
export const getPaymentSettings = createSelector(getAuth, state => state.paymaent_settings);
export const hasAcceptedTermsAndConditions = createSelector(getAuth, state => state.has_accepted_terms_and_conditions);
export const getSepaAgreements = createSelector(getAuth, state => state.sepa_agreements);
export const getProjectLang = createSelector(getAuth, state => state.project_lang);
export const isActive = createSelector(getAuth, state => state.is_active);
export const isEmployee = createSelector(getAuth, state => may('ROLE_EMPLOYEE', state.roles));
export const isCustomer = createSelector(getAuth, state => may('ROLE_CUSTOMER', state.roles));
export const getVoipDeviceToken = createSelector(getAuth, state => state.voipDeviceToken);
export const isLoginPending = createSelector(getAuth, state => state.loginPending);
export const isLogoutPending = createSelector(getAuth, state => state.logoutPending);
export const isPending = createSelector(getAuth, state => state.loginPending || state.logoutPending);

export default {
  getAuth,
  isAuthenticated,
  getId,
  getProfile,
  getName,
  getFirstName,
  getLastName,
  getFinancial,
  getSubscription,
  getLocations,
  getLang,
  getTeams,
  getLocation,
  getPaymentSettings,
  hasAcceptedTermsAndConditions,
  getSepaAgreements,
  getProjectLang,
  isActive,
  isEmployee,
  isCustomer,
  getVoipDeviceToken,
  isLoginPending,
  isLogoutPending,
};
